function parseResultWithSchema(result, schema) {
    const parsed = schema.safeParse(result);

    if (!parsed.success) {
        try {
            JSON.parse(parsed.error).map((error) => {
                if (error.path.length === 1) {
                    console.error(
                        `DEDALO_DATA_ERROR: table "${result.table}" id "${
                            result.section_id
                        }" field "${error.path.join(',')}". ${error.message}.`
                    );
                } else {
                    let target = result;
                    for (let i = 0; i < error.path.length - 1; i += 2) {
                        const prop = error.path[i];
                        const idx = error.path[i + 1];
                        target = target?.[prop]?.[idx];
                        if (!target) break;
                    }
                    const table = target?.table || result.table;
                    const section_id = target?.section_id || result.section_id;
                    const field = error.path[error.path.length - 1];

                    console.error(
                        `DEDALO_DATA_ERROR: table "${table}" id "${section_id}" field "${field}". ${error.message}.`
                    );
                }
            });
        } catch (e) {
            console.error('DEDALO_DATA_ERROR: failed to parse error details', e);
        }
    }
}

export function validateDedaloResultWithSchema(json, schema, dedalo_get) {
    if (dedalo_get === 'combi') {
        json.result.map((res) => {
            if (res.result === null) console.error('DEDALO_DATA_ERROR: ' + res.msg);
        })
    }

    const result = json.result;

    const noArray = ['fragment_from_index_locator', 'combi'];
    const isResultArray = noArray.includes(dedalo_get) ? false : true;

    if (isResultArray) {
        result.map((item) => {
            parseResultWithSchema(item, schema);
        });
    } else {
        parseResultWithSchema(result, schema);
    }
}
